import _ from 'lodash';
import * as styles from './FileManagerCrumbs.module.less';

import { IFolder } from "./model/fileModel";
import { Icon, Icons } from '../Buttons';

function takeLeft<T>(arr: T[], val: T) {
    const result:T[] = [];
    for (let ii of arr) {
        result.push(ii);
        if (ii === val)
            break;
    }
    return result;
}

export interface IFileManagerCrumbsProps {
    path: IFolder[];
    setPath: (path: IFolder[]) => void;
}

export function FileManagerCrumbs({path, setPath}: IFileManagerCrumbsProps) {
    return (
        <div className={styles.pathCrumbs}>
            <div>
                <button className={styles.pathCrumbButton} onClick={() => setPath([])}><Icon icon={Icons.Home}/> Dokument</button>
            </div>
            {
                path.map(x => (
                    <div key={x.id}>
                        <span className={styles.divider}>/</span>
                        <button className={styles.pathCrumbButton} onClick={() => setPath(takeLeft(path, x))}>{x.name}</button>
                    </div>
                ))
            }
        </div>
    );
}